








































import {
  Component,
  Emit,
  Model,
  Prop,
  Vue,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, Mutation } from "vuex-class";
import SkipDelayCount from "../skipDelayCount/SkipDelayCount.vue";
import * as types from "@/store/constants/types";
import GeneralUtilsHelper from "@/utils/generalUtils";
import { isIos } from "@/utils/lodash";
import { sendEvent, sendEventWithParams } from "@/utils/analytics";

@Component({
  components: {
    // [Tabbar.name]: Tabbar,
    SkipDelayCount
  }
})
export default class BackUpApp extends Vue {
  @Prop({ default: 0 })
  private skipDelayCountNum!: number;
  @Getter(types.GETTER_BACK_UP_APP_DESC)
  private superPayDesc: any;
  @Getter(types.GETTER_BACK_UP_APP_CONFIG)
  private superPayAppConfig: any;
  @Getter(types.GETTER_BACK_UP_APP_PARAMS)
  private superPayParams: any;
  @Getter(types.GETTER_BACK_UP_APP_HAS_INSTALLED)
  private superPayAppHasInstalled: any;

  get isLoginUser() {
    return GeneralUtilsHelper.isLoginUser();
  }

  get isIos() {
    return isIos();
  }

  get showReward() {
    return this.isLoginUser && !this.superPayAppHasInstalled;
  }

  get superPayAppStarText() {
    return this.superPayAppConfig.appStar
      ? this.superPayAppConfig.appStar + ".0"
      : "5.0";
  }

  private mounted() {
    sendEventWithParams("uia_recommend_app_show", {
      back_up: "earn_coins"
    });
  }
}
